import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import SettingsPanel from '../../../../components/Editor/EditPanel/SettingsPanel';
import { getClientAndResourceIds } from '../../utils/helpers';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { template: { publicationSettings } },
		editor: { settings: { fields, serverErrors } },
	} = state;
	const { originalGId: publicationId } = getClientAndResourceIds();

	return {
		publicationId,
		settingNames: publicationSettings,
		settings: fields,
		serverErrors,
	};
};

export default connect(mapStateToProps)(SettingsPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SettingsPanel/index.tsx